var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from "react";
import { TextField, Grid, Box, Typography, } from "@mui/material";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomModal from "../modal/CustomModal";
import OriginApi from "../../../infrastructure/api/pages/origin-api";
import { useTranslation } from "react-i18next";
const validationSchema = (translate) => yup.object().shape({
    id: yup.string().optional(),
    name: yup.string().required(translate("NameRequired")),
    backgroundColor: yup.string().required(translate("BackgroundColorRequired")),
    textColor: yup.string().required(translate("TextColorRequired")),
});
const OriginFormSubmit = ({ open, onClose, GetOrigins, initialFormData, data, title, }) => {
    const [saving, setSaving] = useState(false);
    const { t: translate } = useTranslation();
    const hiddenButtonRef = useRef(null);
    const { reset, handleSubmit, control, register, formState: { errors }, } = useForm({
        resolver: yupResolver(validationSchema(translate)),
    });
    const onCloseModal = () => {
        reset(initialFormData);
        onClose();
    };
    const onSubmit = (formData) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        setSaving(true);
        try {
            let response;
            if (formData.id) {
                // Update existing origin
                const updateData = {
                    id: formData.id,
                    name: formData.name,
                    backgroundColor: formData.backgroundColor,
                    textColor: formData.textColor,
                };
                response = yield OriginApi.updateOrigin(updateData);
            }
            else {
                // Create new origin
                const createData = {
                    name: formData.name,
                    backgroundColor: formData.backgroundColor,
                    textColor: formData.textColor,
                };
                response = yield OriginApi.createOrigin(createData);
            }
            if ((response === null || response === void 0 ? void 0 : response.status) === 200 && (response === null || response === void 0 ? void 0 : response.data)) {
                toast.success(translate(formData.id ? "UpdatedSuccessfully" : "SavedSuccessfully"));
                onCloseModal();
                GetOrigins();
                reset(initialFormData);
            }
        }
        catch (error) {
            const errorMessage = ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || ((_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) || (error === null || error === void 0 ? void 0 : error.message);
            // Handle specific error cases
            if (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.includes("already exists")) {
                toast.error(translate("OriginNameAlreadyExists") || errorMessage);
            }
            else {
                toast.error(translate("InternalServerError"));
            }
        }
        finally {
            setSaving(false);
        }
    });
    useEffect(() => {
        reset(data);
    }, [data, reset]);
    return (_jsx(CustomModal, { open: open, onClose: onCloseModal, size: "sm", saving: saving, handleSaveButtonClick: () => { var _a; return (_a = hiddenButtonRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, heading: title, saveButtonText: translate("Save"), disabled: false, children: _jsx(Grid, { container: true, spacing: 0, children: _jsx(Grid, { size: {
                    lg: 8,
                    xs: 12
                }, sx: {
                    mx: "auto"
                }, children: _jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [_jsx("input", Object.assign({ type: "hidden" }, register("id"))), _jsx(Controller, { name: "name", control: control, defaultValue: data.name, render: ({ field }) => {
                                var _a;
                                return (_jsx(TextField, Object.assign({ label: translate("Name"), variant: "outlined", fullWidth: true, margin: "normal" }, field, { error: !!errors.name, helperText: (_a = errors.name) === null || _a === void 0 ? void 0 : _a.message })));
                            } }), _jsxs(Box, { sx: { mt: 2, mb: 1 }, children: [_jsx(Typography, { variant: "body2", gutterBottom: true, sx: {
                                        color: "text.secondary"
                                    }, children: translate("BackgroundColor") }), _jsx(Controller, { name: "backgroundColor", control: control, defaultValue: data.backgroundColor, render: ({ field }) => {
                                        var _a;
                                        return (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [_jsx(TextField, Object.assign({ type: "color", variant: "outlined" }, field, { error: !!errors.backgroundColor, helperText: (_a = errors.backgroundColor) === null || _a === void 0 ? void 0 : _a.message, sx: { width: "80px" } })), _jsx(TextField, { value: field.value, onChange: field.onChange, variant: "outlined", fullWidth: true, placeholder: "#FFFFFF" })] }));
                                    } })] }), _jsxs(Box, { sx: { mt: 2, mb: 1 }, children: [_jsx(Typography, { variant: "body2", gutterBottom: true, sx: {
                                        color: "text.secondary"
                                    }, children: translate("TextColor") }), _jsx(Controller, { name: "textColor", control: control, defaultValue: data.textColor, render: ({ field }) => {
                                        var _a;
                                        return (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [_jsx(TextField, Object.assign({ type: "color", variant: "outlined" }, field, { error: !!errors.textColor, helperText: (_a = errors.textColor) === null || _a === void 0 ? void 0 : _a.message, sx: { width: "80px" } })), _jsx(TextField, { value: field.value, onChange: field.onChange, variant: "outlined", fullWidth: true, placeholder: "#000000" })] }));
                                    } })] }), _jsx("button", { ref: hiddenButtonRef, type: "submit", hidden: true })] }) }) }) }));
};
export default OriginFormSubmit;
